/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _page = __webpack_require__(2);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _poly = __webpack_require__(5);
	
	var _poly2 = _interopRequireDefault(_poly);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (navigator.userAgent.indexOf('Safari/') > -1 && navigator.userAgent.indexOf('Chrome/') === -1) {
	    document.body.className = 'no-anim';
	}
	
	(0, _page2.default)(window.location.pathname.replace(/\//g, ''), true);
	window.goto = _page2.default;
	
	var greetings = ['Hi.', 'G’day.', 'Hey.', 'Hi!', 'Hi,', 'Hi,', 'Hola!', 'Hallo,', 'Ahoyhoy,', 'Ahoy,'];
	var greeting = greetings[parseInt(Math.random() * greetings.length)];
	
	document.querySelector('.content-container.home .site-title span').textContent = greeting;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _nav = __webpack_require__(3);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _poly = __webpack_require__(5);
	
	var _poly2 = _interopRequireDefault(_poly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALID_PAGES = ['', 'about', 'projects', 'contact'];
	
	exports.default = function (path, forceUpdate) {
	    var page = '';
	    if (VALID_PAGES.indexOf(path) > -1) {
	        page = path;
	    } else {
	        window.history.replaceState(null, null, '/');
	    }
	    if (forceUpdate) {
	        (0, _nav2.default)(page);
	    }
	    if (page === 'projects') {
	        document.querySelectorAll('[data-srcset]').forEach(function (source) {
	            source.setAttribute('srcset', source.getAttribute('data-srcset'));
	            source.removeAttribute('data-src');
	        });
	        document.querySelectorAll('[data-src]').forEach(function (img) {
	            img.setAttribute('src', img.getAttribute('data-src'));
	            img.removeAttribute('data-src');
	        });
	    }
	    if (path !== window.location.pathname.replace(/\//g, '')) {
	        (0, _nav2.default)(page);
	        (0, _poly2.default)();
	        window.history.pushState(page, page, '/' + page);
	    }
	    return false;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _scroll = __webpack_require__(4);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentPage = null;
	
	var removeClass = function removeClass(el, cls) {
	    el.className = el.className.replace(cls, '').replace(' ' + cls, '');
	};
	
	var updateNav = function updateNav(page) {
	    page = page ? page : 'home';
	    var noAnim = document.body.className.indexOf('no-anim') > -1;
	    document.body.className = page + (noAnim ? ' no-anim' : '');
	    if (currentPage && currentPage !== page) {
	        var divOut = document.querySelector('.content-container.' + currentPage);
	        var divIn = document.querySelector('.content-container.' + page);
	        // unhide divIn
	        removeClass(divIn, /\s*hidden\s*/);
	        if (noAnim) {
	            divOut.className += ' hidden';
	            (0, _scroll2.default)(divIn);
	            currentPage = page;
	            return;
	        }
	        var goingDown = divOut.getAttribute('data-index') > divIn.getAttribute('data-index');
	        if (goingDown) {
	            // go down
	            divOut.className += ' going-down';
	            divIn.className += ' coming-down';
	        } else {
	            // go up
	            divOut.className += ' going-up';
	            divIn.className += ' coming-up';
	        }
	        setTimeout(function () {
	            if (goingDown) {
	                removeClass(divOut, /\s*going-down\s*/);
	                removeClass(divIn, /\s*coming-down\s*/);
	            } else {
	                removeClass(divOut, /\s*going-up\s*/);
	                removeClass(divIn, /\s*coming-up\s*/);
	            }
	            divOut.className += ' hidden';
	            (0, _scroll2.default)(divIn);
	        }, 990);
	    }
	    currentPage = page;
	};
	
	updateNav();
	(0, _scroll2.default)(document.querySelector('.content-container.home'));
	
	window.onpopstate = function (event) {
	    updateNav(event.path[0].location.pathname.replace(/\//g, ''));
	};
	
	exports.default = updateNav;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var indicatorDown = document.querySelector('.scroll-indicator.down');
	var indicatorUp = document.querySelector('.scroll-indicator.up');
	var indicatorDownProgress = document.querySelector('.scroll-indicator.down .progress');
	var indicatorUpProgress = document.querySelector('.scroll-indicator.up .progress');
	var directionIsDown = true;
	var progress = 0;
	var decayInterval = null;
	var decayTimeout = null;
	
	var listener = null;
	
	var PAGES = ['home', 'about', 'projects', 'contact'];
	
	var updateUI = function updateUI(val) {
	    if (directionIsDown) {
	        indicatorUpProgress.style.height = '0px';
	        indicatorDownProgress.style.height = val / 2 + 'px';
	        indicatorDown.style.opacity = 1;
	    } else {
	        indicatorDownProgress.style.height = '0px';
	        indicatorUpProgress.style.height = val / 2 + 'px';
	        indicatorUp.style.opacity = 1;
	    }
	    if (val === 0) {
	        indicatorDown.style.opacity = 0;
	        indicatorUp.style.opacity = 0;
	    }
	};
	
	var decay = function decay() {
	    if (progress >= 4) {
	        progress *= 0.75;
	    } else {
	        progress--;
	    }
	    if (progress <= 0) {
	        progress = 0;
	        killDecayInterval(decayInterval);
	    }
	    updateUI(progress);
	};
	
	var killDecayInterval = function killDecayInterval() {
	    clearInterval(decayInterval);
	    decayInterval = null;
	};
	
	var killDecayTimeout = function killDecayTimeout() {
	    clearTimeout(decayTimeout);
	    decayTimeout = null;
	};
	
	var scrollListener = function scrollListener(target, pageUp, pageDown) {
	    return function (event) {
	        var atBottom = target.scrollHeight - target.scrollTop <= window.innerHeight;
	        var atTop = target.scrollTop <= 0;
	        killDecayInterval(decayInterval);
	        killDecayTimeout(decayTimeout);
	        if (atBottom && event.deltaY > 0 && pageDown !== undefined) {
	            if (!directionIsDown) {
	                directionIsDown = true;
	                progress = 0;
	            }
	            progress += event.deltaY / 10;
	            if (progress >= 100) {
	                target.removeEventListener('mousewheel', listener);
	                window.goto(pageDown);
	                progress = 0;
	            }
	            updateUI(progress);
	        } else if (atTop && event.deltaY < 0 && pageUp !== undefined) {
	            if (directionIsDown) {
	                directionIsDown = false;
	                progress = 0;
	            }
	            progress -= event.deltaY / 10;
	            if (progress >= 100) {
	                target.removeEventListener('mousewheel', listener);
	                window.goto(pageUp);
	                progress = 0;
	            }
	            updateUI(progress);
	        } else {
	            progress = 0;
	            updateUI(progress);
	        }
	        decayTimeout = setTimeout(function () {
	            if (progress > 0 && decayInterval === null) {
	                decayInterval = setInterval(decay, 1000 / 60);
	            }
	        }, 1000);
	    };
	};
	
	exports.default = function (target) {
	    var index = target.getAttribute('data-index') - 1;
	    progress = 0;
	    updateUI(progress);
	    listener = scrollListener(target, PAGES[index - 1], PAGES[index + 1]);
	    target.addEventListener('mousewheel', listener, { passive: true });
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _polygenMin = __webpack_require__(6);
	
	var _polygenMin2 = _interopRequireDefault(_polygenMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	document.getElementById('polygen').setAttribute('height', window.innerHeight);
	document.getElementById('polygen').setAttribute('width', Math.max(1200, window.innerWidth));
	var hue = Math.random() * 256;
	(0, _polygenMin2.default)(document.getElementById('polygen'), {
	    hue: hue,
	    split: 6,
	    padding: 1,
	    colorgen: 'fade_down'
	});
	document.body.style.setProperty('--base-color', 'hsl(' + hue + ', 75%, 75%)');
	
	exports.default = function () {
	    if (document.body.className.indexOf('no-anim') === -1) {
	        var _hue = Math.random() * 256;
	        (0, _polygenMin2.default)(document.getElementById('polygen'), {
	            hue: _hue
	        });
	        document.body.style.setProperty('--base-color', 'hsl(' + _hue + ', 75%, 75%)');
	    }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var t = {};var r = { basic_light: function basic_light(t, r) {
	      return a(t, 50, 30 + 30 * Math.cos(r[0].x - r[1].x + r[2].x - r[0].y + r[1].y - r[2].y));
	    }, basic_dark: function basic_dark(t, r) {
	      return a(t, 50, 50 - 111 * (r[0].x + r[1].x + r[2].x + r[0].y + r[1].y + r[2].y) % 25);
	    }, fade_streak: function fade_streak(t, r) {
	      return a(t, 50, 25 * Math.sin((r[0].x + r[0].y) / 2 * Math.PI) + 50);
	    }, fade_down: function fade_down(t, r) {
	      var n = 25;var e = 16 * Math.sin(r[2].x * Math.PI) + 16 * Math.cos(r[2].y * Math.PI);var i = 4 * Math.sin(r[1].x * Math.PI) + 4 * Math.cos(r[1].y * Math.PI);return a(t, 50, Math.max(n + e + i, n));
	    }, fade_center: function fade_center(t, r) {
	      var n = function n(t) {
	        return t * t;
	      };var e = Math.sqrt(n(r[0].x - .5) + n(r[0].y - .5));var i = Math.max(50, 20 + 50 * (1 - e));return a(t, 50, i);
	    } };var a = function a(t, r, _a) {
	    return "hsl(" + t + ", " + (r ? r : 50) + "%, " + (_a ? _a : 50) + "%)";
	  };var n = function n(t, r, a) {
	    return { x: t.x + (r.x - t.x) * a, y: t.y + (r.y - t.y) * a };
	  };var e = function e(t) {
	    var r = [];var a = t.splitx + t.padding * 2;var n = t.splity + t.padding * 2;for (var e = -t.padding; e < n; e++) {
	      var i = [];for (var o = -t.padding; o < a; o++) {
	        var l = Math.random() * Math.PI * 2;var s = Math.random() / (2 * t.splitx) * t.overbound;var v = Math.random() / (2 * t.splity) * t.overbound;i.push({ x: o / t.splitx + s * Math.cos(l) + 1 / (2 * t.splitx), y: e / t.splity + v * Math.cos(l) + 1 / (2 * t.splity) });
	      }r.push(i);
	    }return r;
	  };return function (a, i) {
	    var o = t[a.getAttribute("id")];if (o && o.anim) clearInterval(o.anim);if (i && i.colorgen && typeof i.colorgen === "string") {
	      if (Object.keys(r).indexOf(i.colorgen) > -1) {
	        i.colorgen = r[i.colorgen];
	      } else {
	        delete i.colorgen;
	      }
	    }i = Object.assign({ hue: Math.random() * 256, splitx: 10, splity: 10, padding: 0, overbound: 1, transition: 1, colorgen: r["basic_dark"] }, o ? o.opts : null, i);if (i.split) {
	      i.splitx = i.split;i.splity = i.split;
	    }var l = i.hue;var s = a.clientWidth;var v = a.clientHeight;var h = a.getContext("2d");var c = function c(t, r, a) {
	      h.beginPath();{
	        h.lineTo(t.x * s, t.y * v);h.lineTo(r.x * s, r.y * v);h.lineTo(a.x * s, a.y * v);h.lineTo(t.x * s, t.y * v);h.fillStyle = i.colorgen(l, [t, r, a]);h.strokeStyle = h.fillStyle;h.fill();h.stroke();
	      }h.closePath();
	    };var u = function u(t) {
	      for (var r = 0; r < t.length - 1; r++) {
	        for (var a = 0; a < t[0].length - 1; a++) {
	          c(t[r][a], t[r][a + 1], t[r + 1][a]);c(t[r][a + 1], t[r + 1][a], t[r + 1][a + 1]);
	        }
	      }
	    };if (!o) {
	      o = t[a.getAttribute("id")] = {};
	    }if (o.verts === undefined || o.verts.length === 0) {
	      var f = e(i);u(f);o.verts = f;
	    } else {
	      var d = e(i);var y = o.verts;var p = o.opts.hue;var x = l - p;var g = .01;o.anim = setInterval(function () {
	        h.clearRect(0, 0, s, v);l = p + x * g;var t = [];for (var r = 0; r < d.length; r++) {
	          var a = [];for (var e = 0; e < d[0].length; e++) {
	            a.push(n(y[r][e], d[r][e], g));
	          }t.push(a);
	        }u(t);g += Math.sin(g * Math.PI) / 30 / i.transition;if (isNaN(g) || g >= .99) {
	          clearInterval(o.anim);
	        }
	      }, 12);o.verts = d;
	    }o.opts = i;return a;
	  };
	}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.f34e6ccae1bc9a87466d.js